import GridUserInformation from '@zeus/core/grid/GridUserInformation';
import ExtractorVersionTag from '_/features/extractors/common/ExtractorVersionTag';
import RestoreVersionButton from '_/features/extractors/versions/RestoreVersionButton';
import { useExtractorVersions } from '_/hooks/useExtractors';
import { TAny } from '_/types/common.types';
import { formatRelativeTime } from '_/utils/dateUtils';
import { compareSort } from '_/utils/formatUtils';
import { Table, Typography } from 'antd';
import { ColumnsType } from 'antd/lib/table/interface';
import React from 'react';

const columnDefs: ColumnsType<Record<string, TAny>> = [
  {
    dataIndex: 'id',
    render: (id: string) => <Typography.Text style={{ fontSize: '12px' }}>{id}</Typography.Text>,
    sortDirections: ['ascend', 'descend'],
    sorter: compareSort('id'),
    title: 'Version',
    width: 300,
  },
  {
    dataIndex: 'formattedTimestamp',
    render: (formattedTimestamp: string, record: Record<string, TAny>) => (
      <div>
        <div>{formattedTimestamp}</div>
        <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
          {formatRelativeTime(record.addedAt)}
        </Typography.Text>
      </div>
    ),
    sortDirections: ['ascend', 'descend'],
    sorter: compareSort('formattedTimestamp'),
    title: 'Uploaded',
    width: 280,
  },
  {
    dataIndex: 'lastEditor',
    render: (_, record) => <GridUserInformation data={record} field="editor" />,
    sortDirections: ['ascend', 'descend'],
    sorter: compareSort('lastEditor'),
    title: 'Uploaded By',
  },
  {
    dataIndex: 'tag',
    render: (_, { tag, previousTag }) => <ExtractorVersionTag current={tag} previous={previousTag} />,
    sortDirections: ['ascend', 'descend'],
    sorter: compareSort('tag'),
    title: 'Git Tag',
    width: 140,
  },
  {
    dataIndex: 'id',
    render: (id) => <RestoreVersionButton versionId={id} />,
    title: 'Actions',
    width: 120,
  },
];

interface ExtractorVersionHistoryProps {
  extractorId?: string;
}

const ExtractorVersionHistory = ({ extractorId }: ExtractorVersionHistoryProps): JSX.Element => {
  // React Query hook to fetch extractor versions
  const { data: extractorVersions = [], isLoading } = useExtractorVersions(extractorId);

  return (
    <Table
      columns={columnDefs}
      dataSource={extractorVersions}
      indentSize={0}
      loading={isLoading}
      pagination={false}
      rowKey="id"
      tableLayout="fixed"
    />
  );
};

export default ExtractorVersionHistory;
